import { z } from 'zod';

export const CoreLocationCustomFieldValueScalarFieldEnumSchema = z.enum(['id','valueString','valueBoolean','valueInt','valueFloat','valueDatetime','valueJson','valueAddressId','valuePicklistItemId','rowTimestamp','customFieldId','locationId']);

export default CoreLocationCustomFieldValueScalarFieldEnumSchema;
